import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/my-profile',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/my-profile',
      name: 'my-profile',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/MyProfile.vue')
    }

  ]
};
export default app;
